module.exports = __webpack_public_path__ + "media/images/pc/reports/main_visual_01-3ca76314f54c7bd3631fdadd81b6486d.jpg";